{
  "labels": {
    "paste": "Dán",
    "pasteAsPlaintext": "Dán kiểu văn bản thuần",
    "pasteCharts": "Dán biểu đồ",
    "selectAll": "Chọn tất cả",
    "multiSelect": "Thêm mới vào Select",
    "moveCanvas": "Di chuyển canvas",
    "cut": "Cắt",
    "copy": "Sao chép",
    "copyAsPng": "Sao chép vào bộ nhớ tạm dưới dạng PNG",
    "copyAsSvg": "Sao chép vào bộ nhớ tạm dưới dạng SVG",
    "copyText": "Sao chép vào bộ nhớ tạm dưới dạng chữ",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Đưa ra trước",
    "sendToBack": "Hạ xuống dưới",
    "bringToFront": "Đưa ra đầu tiên",
    "sendBackward": "Hạ xuống cuối",
    "delete": "Xóa",
    "copyStyles": "Sao chép định dạng",
    "pasteStyles": "Dán định dạng",
    "stroke": "Nét",
    "background": "Nền",
    "fill": "Fill",
    "strokeWidth": "Độ dày nét",
    "strokeStyle": "Kiểu nét",
    "strokeStyle_solid": "Khối",
    "strokeStyle_dashed": "Gạch ngang",
    "strokeStyle_dotted": "Nhiều chấm",
    "sloppiness": "Hoa văn nét",
    "opacity": "Độ trong suốt",
    "textAlign": "Căn chỉnh văn bản",
    "edges": "Cạnh",
    "sharp": "Nhọn",
    "round": "Tròn",
    "arrowheads": "Đầu mũi tên",
    "arrowhead_none": "Không",
    "arrowhead_arrow": "Mũi tên",
    "arrowhead_bar": "Thanh",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Tam giác",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Cỡ chữ",
    "fontFamily": "Phông chữ",
    "addWatermark": "Làm với Excalidraw\"",
    "handDrawn": "Vẽ tay",
    "normal": "Bình thường",
    "code": "Mã",
    "small": "Nhỏ",
    "medium": "Vừa",
    "large": "Lớn",
    "veryLarge": "Rất lớn",
    "solid": "Đặc",
    "hachure": "Nét gạch gạch",
    "zigzag": "Zigzag",
    "crossHatch": "Nét gạch chéo",
    "thin": "Mỏng",
    "bold": "In đậm",
    "left": "Trái",
    "center": "Giữa",
    "right": "Phải",
    "extraBold": "Nét siêu đậm",
    "architect": "Kiến trúc sư",
    "artist": "Nghệ sỹ",
    "cartoonist": "Hoạt hình",
    "fileTitle": "Tên tập tin",
    "colorPicker": "Chọn màu",
    "canvasColors": "Đã dùng trên canvas",
    "canvasBackground": "Nền canvas",
    "drawingCanvas": "Canvas vẽ",
    "layers": "Lớp",
    "actions": "Chức năng",
    "language": "Ngôn ngữ",
    "liveCollaboration": "Hợp tác trực tiếp...",
    "duplicateSelection": "Tạo bản sao",
    "untitled": "Không có tiêu đề",
    "name": "Tên",
    "yourName": "Tên của bạn",
    "madeWithExcalidraw": "Làm với Excalidraw",
    "group": "Gộp nhóm lại lựa chọn",
    "ungroup": "Tách nhóm lựa chọn",
    "collaborators": "Cộng tác viên",
    "showGrid": "Hiển thị lưới",
    "addToLibrary": "Thêm vào thư viện",
    "removeFromLibrary": "Xóa khỏi thư viện",
    "libraryLoadingMessage": "Đang tải thư viện…",
    "libraries": "Xem thư viện",
    "loadingScene": "Đang tải về…",
    "align": "Căn chỉnh",
    "alignTop": "Căn trên",
    "alignBottom": "Căn dưới",
    "alignLeft": "Canh trái",
    "alignRight": "Canh phải",
    "centerVertically": "Giữa theo chiều dọc",
    "centerHorizontally": "Giữa theo chiều ngang",
    "distributeHorizontally": "Phân bố theo chiều ngang",
    "distributeVertically": "Phân bố theo chiều dọc",
    "flipHorizontal": "Lật ngang",
    "flipVertical": "Lật dọc",
    "viewMode": "Chế độ xem",
    "share": "Chia sẻ",
    "showStroke": "Hiển thị chọn màu",
    "showBackground": "Hiện thị chọn màu nền",
    "toggleTheme": "",
    "personalLib": "Thư viện cá nhân",
    "excalidrawLib": "Thư viện Excalidraw",
    "decreaseFontSize": "Giảm cỡ chữ",
    "increaseFontSize": "Tăng cỡ chữ",
    "unbindText": "",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "Sửa liên kết",
      "editEmbed": "",
      "create": "Tạo liên kết",
      "createEmbed": "",
      "label": "Liên kết",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "Điều chỉnh nét",
      "exit": "Thoát chỉnh nét"
    },
    "elementLock": {
      "lock": "Khoá",
      "unlock": "Mở khoá",
      "lockAll": "Khóa tất cả",
      "unlockAll": "Mở khóa tất cả"
    },
    "statusPublished": "Đã đăng tải",
    "sidebarLock": "Giữ thanh bên luôn mở",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "Chưa có món nào...",
    "hint_emptyLibrary": "Chọn một món trên canvas để thêm nó vào đây, hoặc cài đặt thư viện từ kho lưu trữ công cộng, ở bên dưới.",
    "hint_emptyPrivateLibrary": "Chọn một món trên canvas để thêm nó vào đây."
  },
  "buttons": {
    "clearReset": "Reset canvas",
    "exportJSON": "Xuất ra tập tin",
    "exportImage": "Xuất file ảnh...",
    "export": "Lưu vào...",
    "copyToClipboard": "Sao chép vào bộ nhớ tạm",
    "save": "Lưu vào tập tin hiện tại",
    "saveAs": "Lưu thành",
    "load": "Mở",
    "getShareableLink": "Tạo liên kết để chia sẻ",
    "close": "Đóng",
    "selectLanguage": "Chọn ngôn ngữ",
    "scrollBackToContent": "Cuộn về nội dung chính",
    "zoomIn": "Phóng to",
    "zoomOut": "Thu nhỏ",
    "resetZoom": "Đặt lại thu phóng",
    "menu": "Bảng chọn",
    "done": "Xong",
    "edit": "Chỉnh sửa",
    "undo": "Hoàn tác",
    "redo": "Làm lại",
    "resetLibrary": "",
    "createNewRoom": "Tạo phòng mới",
    "fullScreen": "Toàn màn hình",
    "darkMode": "Chế độ tối",
    "lightMode": "Chế độ sáng",
    "zenMode": "Chế độ zen",
    "objectsSnapMode": "",
    "exitZenMode": "Thoát chể độ zen",
    "cancel": "Hủy",
    "clear": "Làm sạch",
    "remove": "Xóa",
    "embed": "",
    "publishLibrary": "Đăng tải",
    "submit": "Gửi",
    "confirm": "Xác nhận",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "Điều này sẽ dọn hết canvas. Bạn có chắc không?",
    "couldNotCreateShareableLink": "Không thể tạo đường dẫn chia sẻ.",
    "couldNotCreateShareableLinkTooBig": "Không thể tạo đường dẫn chia sẻ: bản vẽ quá lớn",
    "couldNotLoadInvalidFile": "Không thể load tập tin không hợp lệ",
    "importBackendFailed": "",
    "cannotExportEmptyCanvas": "Không thể xuất canvas trống.",
    "couldNotCopyToClipboard": "",
    "decryptFailed": "Không thể giải mã dữ liệu.",
    "uploadedSecurly": "",
    "loadSceneOverridePrompt": "",
    "collabStopOverridePrompt": "Dừng phiên sẽ ghi đè lên bản vẽ được lưu trữ cục bộ trước đó của bạn. Bạn có chắc không?\n\n(Nếu bạn muốn giữ bản vẽ cục bộ của mình, chỉ cần đóng tab trình duyệt.)",
    "errorAddingToLibrary": "Không thể thêm món vào thư viện",
    "errorRemovingFromLibrary": "Không thể xoá món khỏi thư viện",
    "confirmAddLibrary": "Hình {{numShapes}} sẽ được thêm vào thư viện. Bạn chắc chứ?",
    "imageDoesNotContainScene": "Hình ảnh này dường như không chứa bất kỳ dữ liệu cảnh nào. Bạn đã bật tính năng nhúng cảnh khi xuất chưa?",
    "cannotRestoreFromImage": "",
    "invalidSceneUrl": "",
    "resetLibrary": "",
    "removeItemsFromsLibrary": "Xoá {{count}} món từ thư viện?",
    "invalidEncryptionKey": "Khóa mã hóa phải có 22 ký tự. Hợp tác trực tiếp bị vô hiệu hóa.",
    "collabOfflineWarning": "Không có kết nối internet.\nThay đổi của bạn sẽ không được lưu!"
  },
  "errors": {
    "unsupportedFileType": "Loại tập tin không được hỗ trợ.",
    "imageInsertError": "Không thể thêm ảnh. Hãy thử lại sau...",
    "fileTooBig": "Tệp tin quá lớn. Dung lượng tối đa cho phép là {{maxSize}}.",
    "svgImageInsertError": "Không thể thêm ảnh SVG. Mã SVG có vẻ sai.",
    "failedToFetchImage": "",
    "invalidSVGString": "SVG không hợp lệ.",
    "cannotResolveCollabServer": "Không thể kết nối với máy chủ hợp tác. Hãy tải lại trang và thử lại.",
    "importLibraryError": "Không thể tải thư viện",
    "collabSaveFailed": "Không thể lưu vào cơ sở dữ liệu. Nếu vấn đề tiếp tục xảy ra, bạn nên lưu tệp vào máy để đảm bảo bạn không bị mất công việc.",
    "collabSaveFailed_sizeExceeded": "Không thể lưu vào cơ sở dữ liệu, canvas có vẻ quá lớn. Bạn nên lưu tệp cục bộ để đảm bảo bạn không bị mất công việc.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Lựa chọn",
    "image": "Chèn ảnh",
    "rectangle": "Hình chữ nhật",
    "diamond": "Kim cương",
    "ellipse": "Hình elíp",
    "arrow": "Mũi tên",
    "line": "Đường kẻ",
    "freedraw": "Vẽ",
    "text": "Văn bản",
    "library": "Thư viện",
    "lock": "Giữ dụng cũ hiện tại sau khi vẽ",
    "penMode": "Chế độ bút vẽ - ngăn ngừa chạm nhầm",
    "link": "Thêm/ Chỉnh sửa liên kết cho hình được chọn",
    "eraser": "Xóa",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "Tay kéo",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "Hành động canvas",
    "selectedShapeActions": "Các hành động cho hình dạng đã chọn",
    "shapes": "Các hình khối"
  },
  "hints": {
    "canvasPanning": "Để di chuyển canvas, giữ con lăn chuột hoặc phím cách trong khi kéo, hoặc sử dụng công cụ cầm tay",
    "linearElement": "Ấn để bắt đầu nhiểm điểm vẽ, kéo để vẽ một đường thẳng",
    "freeDraw": "Ấn bà kéo, thả khi bạn xong",
    "text": "Mẹo: bạn có thể thêm văn bản tại bất cứ đâu bằng cách ấn hai lần bằng tool lựa chọn",
    "embeddable": "",
    "text_selected": "Ấn 2 lần hoặc nhấn ENTER để chỉnh văn bản",
    "text_editing": "Nhấn Escape hoặc Ctrl/Cmd+ENTER để hoàn thành chỉnh sửa",
    "linearElementMulti": "Nhấn vào điểm cuối hoặc nhấn Escape hoặc Enter để kết thúc",
    "lockAngle": "Bạn có thể chỉnh lại góc bằng cách giữ phím SHIFT",
    "resize": "Bạn có thể chỉnh tỷ lệ bằng cách giữ SHIFT khi chỉnh kích cỡ,\ngiữ ALT để chỉnh kích cỡ từ trung tâm",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "placeImage": "",
    "publishLibrary": "",
    "bindTextToElement": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "Tính năng này có thể được bật bằng cách đặt cờ \"dom.events.asyncClipboard.clipboardItem\" thành \"true\". Để thay đổi cờ trình duyệt trong Firefox, hãy truy cập trang \"about:config\".",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Không thể xem trước",
    "canvasTooBig": "Canvas này có thể hơi lớn.",
    "canvasTooBigTip": "Mẹo: hãy thử di chuyển các elements nhất lại gần nhau hơn một chút."
  },
  "errorSplash": {
    "headingMain": "",
    "clearCanvasMessage": "Nếu không tải lại được, hãy thử <button>dọn canvas.</button>",
    "clearCanvasCaveat": " Điều này sẽ dẫn đến mất dữ liệu bạn đã làm ",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "",
    "button_stopSession": "",
    "desc_inProgressIntro": "",
    "desc_shareLink": "",
    "desc_exitSession": "",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": ""
  },
  "exportDialog": {
    "disk_title": "",
    "disk_details": "",
    "disk_button": "",
    "link_title": "",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "",
    "click": "",
    "deepSelect": "",
    "deepBoxSelect": "",
    "curvedArrow": "",
    "curvedLine": "",
    "documentation": "",
    "doubleClick": "",
    "drag": "",
    "editor": "",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "",
    "howto": "",
    "or": "",
    "preventBinding": "",
    "tools": "",
    "shortcuts": "",
    "textFinish": "",
    "textNewLine": "",
    "title": "",
    "view": "",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": ""
  },
  "clearCanvasDialog": {
    "title": "Dọn canvas"
  },
  "publishDialog": {
    "title": "",
    "itemName": "Tên món",
    "authorName": "",
    "githubUsername": "",
    "twitterUsername": "",
    "libraryName": "",
    "libraryDesc": "",
    "website": "",
    "placeholder": {
      "authorName": "",
      "libraryName": "",
      "libraryDesc": "",
      "githubHandle": "",
      "twitterHandle": "",
      "website": ""
    },
    "errors": {
      "required": "",
      "website": ""
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "Từng món trong thư viện phải có tên riêng để có thể lọc. Các món thư viện sau đây sẽ thêm:",
    "atleastOneLibItem": "Vui lòng chọn ít nhất một món thư viện để bắt đầu",
    "republishWarning": "Lưu ý: một số món đã chọn được đánh dấu là đã xuất bản/đã gửi. Bạn chỉ nên gửi lại các món khi cập nhật thư viện hiện có hoặc gửi."
  },
  "publishSuccessDialog": {
    "title": "",
    "content": ""
  },
  "confirmDialog": {
    "resetLibrary": "",
    "removeItemsFromLib": "Xóa món đã chọn khỏi thư viện"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "",
    "element": "",
    "elements": "",
    "height": "",
    "scene": "",
    "selected": "",
    "storage": "",
    "title": "",
    "total": "",
    "version": "",
    "versionCopy": "",
    "versionNotAvailable": "",
    "width": ""
  },
  "toast": {
    "addedToLibrary": "",
    "copyStyles": "",
    "copyToClipboard": "",
    "copyToClipboardAsPng": "",
    "fileSaved": "",
    "fileSavedToFilename": "",
    "canvas": "canvas",
    "selection": "",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
